import { Card } from '../components/Card'
import { Cashback } from './Cashback'
import { Header } from '../components/Header'

import { Pet } from './Pet'

export function Client() {
  return (
    <>
      <Header.Customer />
      <Card.Root>
        <Card.Main>
          <Cashback />
          <Pet />
        </Card.Main>
      </Card.Root>
    </>
  )
}
